import { render, staticRenderFns } from "./ModalEliminarDocumento.vue?vue&type=template&id=15498220&scoped=true"
import script from "./ModalEliminarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalEliminarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15498220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15498220')) {
      api.createRecord('15498220', component.options)
    } else {
      api.reload('15498220', component.options)
    }
    module.hot.accept("./ModalEliminarDocumento.vue?vue&type=template&id=15498220&scoped=true", function () {
      api.rerender('15498220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalEliminarDocumento.vue"
export default component.exports